import { ThunkDispatch } from "core-integration/src/store";
import { logout } from "core-integration/src/store/player/thunks";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getIsWebView } from "../../utils/webView";

const Logout: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch>();

  const handleLogout = async () => dispatch(logout());

  useEffect(() => {
    (async () => {
      if (getIsWebView()) {
        await handleLogout().then(() => window.location.replace("/?webview=1"));
      } else {
        await handleLogout().then(() => window.location.replace("/"));
      }
    })();
  }, []);

  return <div />;
};

export default Logout;
